import { NoDataState } from "@/design-system/NoDataState";
import { isHttpError } from "@/helpers/Network/errors";
import { useTranslation } from "@/translations";

interface Props {
  error?: unknown;
  noDataMessage?: string;
  onReload?: () => void;
  horizontal?: boolean;
}

export function NoData({ horizontal, error, noDataMessage: errorMessage, onReload }: Props): React.ReactNode {
  const { t } = useTranslation();

  const isFailure = isHttpError(error) && error.status !== 404;

  const title = isFailure
    ? t("page.analytics-overview.error.load-failed.title")
    : t("page.analytics-overview.error.no-data.title");
  const description = isFailure
    ? t("page.analytics-overview.error.load-failed.description")
    : errorMessage || t("page.analytics-overview.error.no-data.description");
  const action = isFailure && onReload ? { label: t("common.action.reload"), onClick: onReload } : undefined;

  return (
    <NoDataState
      title={title}
      description={description}
      orientation={horizontal ? "horizontal" : "vertical"}
      action={action}
    />
  );
}
